// extracted by mini-css-extract-plugin
export var noticeIcon = "notice-styles-module--notice-icon--0e825";